import { createSlice } from "@reduxjs/toolkit";

const initState = {
  count: 0,
};

export const archiveSlice = createSlice({
  name: "archive",
  initialState: initState,
  reducers: {
    setArchiveCountReducer: (state, action) => {
      let tempObj = { ...state, ...action.payload };
      return tempObj;
    },
    resetArchiveCountReducer: () => initState,
  },
});

export const { setArchiveCountReducer, resetArchiveCountReducer } =
  archiveSlice.actions;

export default archiveSlice.reducer;
